import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import DocumentService from '../../services/DocumentService';
import pdfimg from '../../public/pdf_view-all.png'
import moment from "moment";
import { showLoading } from 'react-global-loading';
import CountryHeader from "./CountryHeader";

export const userData = localStorage.getItem('persist:root') ?
  JSON.parse(JSON.parse(localStorage.getItem('persist:root')).userData) : '';

const CountryDocuments = (props) => {
  const [countryId, setCountryId] = useState(props.match.params.id);
  const [categoryId, setCategoryId] = useState(props.match.params.catId);
  const [document_upload, setDocument] = useState();
  const [documentsList, setDocumentsList] = useState([]);

  useEffect(() => {
    showLoading(false);
    getDocumentList();
  }, []);

  const getDocumentList = () => {
    DocumentService.getAllDocumentByCountry({ 'blog_id': countryId, 'category': categoryId })
      .then((result) => {
        if (!result) {
          return;
        }

        console.log("Full API Response:", result); // Log the full API response
        setDocumentsList(result);
        showLoading(false);
      })
      .catch((err) => {
        console.error(err);
      });
  };
  const handleCallback = (childData) => {

    setCategoryId(childData.id)
  };
  const handleDocumentClick = (item) => {
    console.log("PDF Path:", item.document_upload);  // Log the PDF path to debug
    setDocument(item.document_upload);
  };

  return (
    <div className="container pt-2">
      <CountryHeader parentCallback={handleCallback} category={categoryId} country={countryId} />

      <div className="row bg-light p-2 pt-4 mt-5 mb-3 rounded rounded-2">
        <div className="col-12">
          <h3 className="mb-3">Documents</h3>
          <div className="row view-group" id="Documents2">
            {/* Document card */}
            {documentsList.length > 0 ? documentsList.map((item, index) =>
              <div key={index} className="col-md-3 mb-3" data-bs-toggle="modal"
                data-bs-target="#docModal" onClick={() => handleDocumentClick(item)}>
                <div className="card p-3 event-card crdev">
                  <div className="imgrel">
                    <img src={pdfimg} className=" card-img-top rounded" alt="events" style={{ width: '50px', objectFit: 'cover' }} />
                  </div>
                  <div className="evtxcn px-0">
                    <h4 className="evh mt-2">
                      <Link to={"/document-details?id=" + item.ID} className="evhd crop-text">{item.post_title}</Link>
                    </h4>
                    <span className="muted d-block mt-1 doccell crop-text">{item.post_title}</span>
                    <p className="evdes_nw">{item.post_content}</p>
                  </div>
                </div>
                <div className="crbotm">
                  <p className="dtpr">Created - <span className="cdte">{moment(item.post_date).format("Do MMM YYYY")}</span></p>
                  <span className="dtpr">/</span>
                  <p className="dtpr">{` Last Updated On - `}<span className="cdte">{moment(item.post_modified).format("Do MMM YYYY")}</span></p>
                </div>
              </div>
            ) : <div className="col-12 mb-4">
              <div className="alert alert-success" role="alert">
                <h4 className="alert-heading">
                  <i className="fa fa-exclamation-circle me-1" aria-hidden="true"></i> Data Not Found!
                </h4>
                <p>We regret to inform you that the requested data could not be located or does not exist in our records. It is possible that the information you are seeking has not been documented, is not publicly available, or has been removed or archived.</p>
              </div>
            </div>
            }
          </div>
        </div>
        <div
          className="modal fade"
          id="docModal"
          tabIndex="-1"
          aria-labelledby="docapprovalLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog modal-xl">
            <div className="modal-content bg-white p-3">
              <div className="modal-header">
                <h1 className="modal-title fs-5 w-100" id="docapprovalLabel">
                  Document Details
                </h1>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                ></button>
              </div>
              <div className="modal-body">
                <div className="row mt-2 pdfht" aria-labelledby="#label1">
                  <object
                    id="#label1"
                    width="100%"
                    height="100%"
                    type="application/pdf"
                    data={document_upload}
                  >
                    <p>PDF cannot be displayed. <a href={document_upload}>Download PDF</a></p>
                  </object>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CountryDocuments;
